import { connect } from "react-redux"
import {
  createContactBackCase,
  getContactBackAttributes,
  getServiceChangeEligibility,
  resetSubmitCancelDetails,
  setCancelMovingButtonClicked,
  setResiLogoutState,
} from "actions-lib"
import { isSingleAccountSelector } from "selectors-lib/linkedAccounts"
import ProfileMenuModal from "./ProfileMenuModal"

const mapDispatchToProps = {
  getServiceChangeEligibility,
  createContactBackCase,
  getContactBackAttributes,
  setCancelMovingButtonClicked,
  setResiLogoutState,
  resetSubmitCancelDetails,
}

export const mapStateToProps = (state) => ({
  cancelService: state.cancelService,
  userAccount: state.userAccount,
  myServices: state.myServices,
  language: state.siteLanguage?.language,
  customerContacts: state.customerContacts,
  customerSelections: state.customerSelections,
  isSingleAccount: isSingleAccountSelector(state),
  userManageAccount: state.userManageAccount,
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenuModal)
